__turbopack_context__.v({
  "root": "skeleton-module__BBtfzW__root",
});
